import { useIntl } from 'react-intl';

import { messages } from './messages';

export const ShippyIcon = () => {
  const intl = useIntl();

  return (
    <svg
      aria-label={intl.formatMessage(messages.iconAlt)}
      fill='none'
      height='20'
      role='img'
      viewBox='0 0 20 20'
      width='20'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_shippy)'>
        <g clipPath='url(#paint0_clip_shippy)'>
          <g transform='matrix(0.000356815 -0.0114293 0.0102068 0.000310892 12.974 12.0335)'>
            <foreignObject height='2029.52' width='2029.52' x='-1014.76' y='-1014.76'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg, rgba(92, 76, 255, 1) 0deg, rgba(142, 144, 254, 1) 60.53deg, rgba(253, 121, 122, 1) 244.04deg, rgba(167, 255, 200, 1) 360deg)',
                  height: '100%',
                  width: '100%',
                }}
                {...{ xmlns: 'http://www.w3.org/1999/xhtml' }}
              />
            </foreignObject>
          </g>
        </g>
        <g clipPath='url(#paint1_clip_shippy)'>
          <g transform='matrix(-0.000356815 0.0116307 -0.0130716 -0.000391259 6.29638 7.80415)'>
            <foreignObject height='1759.94' width='1759.94' x='-879.968' y='-879.968'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg, rgba(103, 97, 255, 1) 0deg, rgba(121, 139, 252, 1) 122.34deg, rgba(2, 225, 105, 1) 236.1deg, rgba(198, 245, 196, 1) 360deg)',
                  height: '100%',
                  width: '100%',
                }}
                {...{ xmlns: 'http://www.w3.org/1999/xhtml' }}
              />
            </foreignObject>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id='paint0_clip_shippy'>
          <path d='M15.5595 3.35707V13.369L9.78107 16.7519L6.77768 14.9931V8.22938L9.78107 6.47062L12.7845 8.22938V4.98016L9.78107 3.22241L4.00269 6.60426V16.6172L9.78107 20.0001L18.3334 14.9931V4.98016L15.5595 3.35707Z' />
        </clipPath>
        <clipPath id='paint1_clip_shippy'>
          <path d='M4.02399 16.643V6.63108L9.80237 3.24821L12.8058 5.00595V11.7707L9.80237 13.5294L6.79898 11.7707V15.0189L9.80237 16.7776L15.5808 13.3958V3.38287L9.80237 0L1.25 5.00595V15.0189L4.02399 16.643Z' />
        </clipPath>
        <clipPath id='clip0_shippy'>
          <rect fill='white' height='20' width='20' />
        </clipPath>
      </defs>
    </svg>
  );
};
